export default __webpack_public_path__ + "../staticImages/sprite-paketshop-2x.png";